import * as React from "react";
const OnVisualizationConfigChangeContext = React.createContext(() => {
});
export default OnVisualizationConfigChangeContext;
